/**
 * Restyle TYDAL / Rivo reviews to NINE NINE brand.
 * One-shot CSS inject — no MutationObserver DOM writes (avoids freeze loops).
 */
(function () {
  if (window.__nnTydalInit) return;
  window.__nnTydalInit = true;

  var STYLE_ID = 'nn-tydal-reviews-css';
  var patched = false;

  var NN_REVIEWS_CSS =
    '#panel-container,#panel-container *:not(svg):not(path){font-family:var(--font-body-family),"IBM Plex Sans",sans-serif!important;box-sizing:border-box}' +
    '#panel-container{color:#ececec;background:transparent;margin:var(--nn-4,36px) 0;padding:0}' +
    '#panel-container #panel-nav{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px;margin:0 0 18px;padding:0 0 18px;border-bottom:1px solid rgba(236,236,236,.12)}' +
    '#panel-container .summary-container,#panel-container .review-summary,#panel-container .review-summary-header,#panel-container .review-summary-title{display:flex;flex-direction:column;align-items:flex-start;gap:9px}' +
    '#panel-container .review-summary-title{flex-direction:row;align-items:center}' +
    '#panel-container .review-summary-total-reviews,#panel-container .summary-text,#panel-container .summary-rating{margin:0;color:#8a8a8a!important;font-size:1.2rem!important;font-weight:500;letter-spacing:.14em;text-transform:uppercase}' +
    '#panel-container .tydal-star-wrapper{display:inline-flex;align-items:center;gap:3px;padding:0!important}' +
    '#panel-container .tydal-star-wrapper svg.star,.tydal-reviews-star-rating svg.star,#panel-container .summary-stars svg{width:18px!important;height:18px!important;fill:#76c043!important;color:#76c043!important}' +
    '#panel-container .write-a-review-container{margin:0}' +
    '#panel-container .panel-btn,#panel-container .rev-write-review,#panel-container #write-review,#panel-container #rev-load-more{display:inline-flex!important;align-items:center;justify-content:center;min-height:54px;padding:9px 27px!important;margin:0!important;font-size:1.2rem!important;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:#76c043!important;background:transparent!important;border:1px solid #76c043!important;border-radius:9px!important;box-shadow:none!important;cursor:pointer;transition:background .2s ease,color .2s ease}' +
    '#panel-container .panel-btn:hover,#panel-container .rev-write-review:hover,#panel-container #write-review:hover,#panel-container #rev-load-more:hover{background:rgba(118,192,67,.14)!important;color:#76c043!important}' +
    '#panel-container p.first-review-text{margin:0;padding:9px 0 0!important;font-size:1.4rem!important;letter-spacing:.04em;color:#8a8a8a!important;text-align:left}' +
    '#panel-container p.first-review-text a{color:#76c043!important;text-decoration:none!important;border-bottom:1px solid rgba(118,192,67,.45);padding-bottom:2px;font-size:inherit!important}' +
    '#panel-container p.first-review-text a:hover{border-bottom-color:#76c043}' +
    '#panel-container .review-card,#panel-container .list-item{background:#1f1f1f!important;border:1px solid rgba(236,236,236,.12)!important;border-radius:9px;box-shadow:none!important;margin:0 0 9px!important;color:#ececec}' +
    '#panel-container .review-card:hover{background:#242424!important;cursor:pointer}' +
    '#panel-container .review-card .review-details,#panel-container .list-item .review-content{padding:18px!important}' +
    '#panel-container .review-card .reviewer,#panel-container .author-name,#panel-container .list-item .review-title{color:#ececec!important;font-weight:500}' +
    '#panel-container .review-card .date,#panel-container .verified-text,#panel-container .recommendation-text{color:#8a8a8a!important}' +
    '#panel-container .review-card .review-text,#panel-container .list-item .review-body,#panel-container .review-reply-text{color:#ececec!important;font-size:1.4rem!important;line-height:1.6}' +
    '#panel-container .list-item{border-bottom:1px solid rgba(236,236,236,.12)!important;padding:18px!important}' +
    '#panel-container .list-item .review-reply{background:rgba(236,236,236,.04)!important;border-left:2px solid #76c043!important;border-radius:0 9px 9px 0;color:#ececec}' +
    '#panel-container .author-circle{background:rgba(118,192,67,.14)!important;color:#76c043!important}' +
    '#panel-container .star-bar{background:rgba(236,236,236,.12)!important}' +
    '#panel-container .star-bar-fill{background:#76c043!important}' +
    '#panel-container.grid-view #review-panel{gap:9px!important}' +
    '.tydal-reviews-star-rating{display:inline-flex;align-items:center;gap:9px}';

  function injectCss() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = NN_REVIEWS_CSS;
    document.head.appendChild(style);
  }

  function patchConfig() {
    if (!window.Tydal || !window.Tydal.rev_config) return false;
    var cfg = window.Tydal.rev_config;
    var colors = cfg.widget_css || {};
    colors.theme_star_color = '#76c043';
    colors.theme_star_text_color = '#ececec';
    colors.theme_title_color = '#ececec';
    colors.theme_subtext_color = '#8a8a8a';
    colors.theme_footer_color = '#8a8a8a';
    colors.theme_link_color = '#76c043';
    colors.theme_button_bg_color = 'transparent';
    colors.theme_button_text_color = '#76c043';
    colors.theme_button_border_color = '#76c043';
    colors.theme_button_hover_color = '#1f1f1f';
    colors.theme_first_review_text_color = '#8a8a8a';
    colors.theme_reviews_title_color = '#ececec';
    colors.theme_reviews_body_color = '#ececec';
    colors.theme_launcher_bg_color = '#1f1f1f';
    colors.theme_launcher_text_color = '#76c043';
    colors.theme_launcher_border_color = '#76c043';
    colors.theme_launcher_hover_bg_color = '#1f1f1f';
    colors.theme_launcher_hover_text_color = '#76c043';
    colors.theme_global_primary_color = '#1f1f1f';
    colors.theme_global_secondary_color = '#76c043';
    colors.theme_global_button_bg_color = 'transparent';
    colors.theme_global_button_text_color = '#76c043';
    colors.theme_input_text_color = '#ececec';
    colors.theme_input_border_color = 'rgba(236,236,236,0.28)';
    cfg.widget_css = colors;

    if (!patched) {
      cfg.custom_css = (cfg.custom_css || '') + '\n' + NN_REVIEWS_CSS;
      if (cfg.widget_settings) {
        cfg.widget_settings.display_panel_custom_class = 'nn-reviews';
        cfg.widget_settings.display_panel_custom_css =
          (cfg.widget_settings.display_panel_custom_css || '') + '\n' + NN_REVIEWS_CSS;
      }
      patched = true;
    }
    return true;
  }

  function paintStars() {
    document
      .querySelectorAll(
        '#panel-container .tydal-star-wrapper svg.star, .tydal-reviews-star-rating svg.star, #panel-container .summary-stars svg'
      )
      .forEach(function (svg) {
        if (svg.getAttribute('fill') !== '#76c043') svg.setAttribute('fill', '#76c043');
        if (svg.style.fill !== 'rgb(118, 192, 67)' && svg.style.fill !== '#76c043') {
          svg.style.fill = '#76c043';
        }
      });
  }

  injectCss();
  patchConfig();
  paintStars();

  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    patchConfig();
    paintStars();
    if (tries > 40) window.clearInterval(timer);
  }, 250);

  // Watch reviews panel only — never write to <head> from the observer
  if (window.MutationObserver) {
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        paintStars();
      });
    });
    function attach() {
      var panel = document.getElementById('panel-container');
      if (panel) {
        obs.observe(panel, { childList: true, subtree: true });
        paintStars();
        return true;
      }
      return false;
    }
    if (!attach()) {
      var wait = window.setInterval(function () {
        if (attach() || tries > 40) window.clearInterval(wait);
      }, 250);
    }
  }
})();
